/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';
import { action } from '@ember/object';

// Define an enum that matches the expected EditorMode type
// Based on the actual enum definition found in the codebase
enum EditorMode {
  NEW = 'new',
  EDIT = 'edit',
  VIEW = 'view',
  REVIEW = 'review',
}

export default class AppStandaloneDeployFreshdeskTicketsWorkflowShowController extends Controller {
  // Using queryParams is the recommended usage for controllers in this codebase
  queryParams = ['activeContentId', 'activeContentType', 'editorMode'];

  // Default values for query params
  activeContentId: number | undefined = undefined;
  activeContentType: string | undefined = undefined;
  editorMode: EditorMode | undefined = undefined;

  @action
  handleContentUpdate(_content: any) {
    // Handle content update logic here
    // Adding underscore prefix to avoid unused parameter warning
  }
}
